<script lang="ts" setup>
import { ref, watch } from 'vue';
import { DgrDialog } from '@stockmarkteam/donguri-ui';
import ThemePerspectiveSelectForm from '@/components/common/theme-perspective-select-form.vue';
import ThemeTopicOneSelectForm from '@/components/common/theme-topic-one-select-form.vue';
import { Perspective, ThemeTopic } from '@/types';
import { useEmitter } from '@/utils/vue';

const open = defineModel<boolean>('open', { default: false });
watch(
  () => open.value,
  () => {
    if (!open.value) {
      selectedTopics.value = undefined;
      isSelectTopic.value = true;
      selectPerspective.value = undefined;
    }
  },
);

const emitter = useEmitter();
const selectedTopics = ref<ThemeTopic[] | undefined>(undefined);
const isSelectTopic = ref<boolean>(true);
const selectPerspective = ref<Perspective | undefined>(undefined);

const selectThemeTopic = (topic: ThemeTopic) => {
  selectedTopics.value = [topic];
  isSelectTopic.value = false;
};

const submit = async () => {
  emitter.emit('select-theme-topics', [
    selectedTopics.value,
    selectPerspective.value,
  ]);
  open.value = false;
};

const selectedPerspective = (perspective: Perspective) => {
  selectPerspective.value = perspective;
  emitter.emit('select-perspective', selectPerspective.value);
};
</script>

<template>
  <DgrDialog title="トピック一覧" v-model:open="open">
    <template #description>
      <div v-if="isSelectTopic" class="o-body c-text-regular--m modal-body">
        <div class="c-text-regular--s">ステップ 1/2</div>
        <div class="c-title-bold--xl">あなたの興味を教えてください</div>
        <div class="spacing-12" />
        <div class="c-text-regular--m">
          あなたの興味や業務に関連しそうなトピックを選んでください。
        </div>
        <ThemeTopicOneSelectForm
          class="theme-topic-select-form"
          @select-theme-topic="selectThemeTopic"
        />
      </div>
      <div v-else class="o-body c-text-regular--m modal-body">
        <div class="c-text-regular--s">ステップ 2/2</div>
        <ThemePerspectiveSelectForm
          class="theme-topic-select-form"
          :select-perspective="selectPerspective"
          @selected-perspective="selectedPerspective"
        />
      </div>
    </template>

    <template #footer>
      <button
        class="o-cancel-button c-btn c-btn--auto c-btnOutline"
        @click="open = false"
      >
        キャンセル
      </button>
      <template v-if="!isSelectTopic">
        <button
          class="o-cancel-button c-btn c-btn--auto c-btnOutline"
          @click="isSelectTopic = true"
        >
          戻る
        </button>
        <button
          class="o-create-button c-btn c-btn--auto c-btn--AnewsPrimary"
          @click="submit"
        >
          追加
        </button>
      </template>
    </template>
  </DgrDialog>
</template>
<style lang="scss" scoped>
.theme-topic-select-form {
  width: 800px;
}
.modal-body {
  overflow: auto;
  height: 50vh;
}
.back-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 20px;
  height: 20px;

  &:hover {
    background: $color-link-menu-hover;
  }
}
</style>
